export default function WrenchIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM2 12C2 6.486 6.486 2 12 2s10 4.486 10 10c0 1.679-.421 3.26-1.155 4.651l-1.377-1.377a3.206 3.206 0 0 1-.93-2.514 6.27 6.27 0 0 0-1.82-4.93A6.238 6.238 0 0 0 12.29 6c-.603 0-1.206.086-1.79.257l3.77 3.771c.41 1.889-2.33 4.66-4.242 4.242l-3.77-3.77a6.346 6.346 0 0 0-.259 1.792c0 1.602.606 3.202 1.829 4.426a6.27 6.27 0 0 0 4.932 1.821 3.21 3.21 0 0 1 2.514.931l1.377 1.376A9.936 9.936 0 0 1 12 22C6.486 22 2 17.514 2 12z" />
    </svg>
  );
}
